<template>
  <symboliek/>
</template>

<script>
import Symboliek from '../components/OpbouwPlechtigheid/Symboliek.vue'

export default {
  name: 'SymboliekView',
  components: {
    Symboliek
  }
}
</script>
